import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, shareReplay, tap } from 'rxjs';
import { AssignmentGroupsRequest } from '../../../document/models/assignment-groups-request';
import { ApiConstants } from '../../../shared/constants/api-constants';
import { AssignmentGroup } from '../models/assignment-group';
import { AssignmentGroupDetails } from '../models/assignment-group-details';
import { EQMSScopeHierarchy } from '../../../shared/models/scopes/eqms-scope-hierarchy';
import { TreeData } from '../../../shared/models/TreeData';
import { TreeNode } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class AssignmentGroupService {
  private eqmsScopeObservable?: Observable<EQMSScopeHierarchy>;
  treeData:EQMSScopeHierarchy = {} as EQMSScopeHierarchy;

  constructor(private httpClient: HttpClient) { }

  getAssignmentGroupLookUpDetails(): Observable<any> {
    return this.httpClient.get(ApiConstants.AssignmentGroup_LookUp_API);
  }

  saveAssignmentGroupDetails(payload: AssignmentGroup): Observable<any> {
    return this.httpClient.post(ApiConstants.AssignmentGroup_api, payload)
  }

  getAssignmentGroupForScope(scope: number, isAllAssignmentGroups: boolean): Observable<AssignmentGroupDetails[]> {
    return this.httpClient.get<AssignmentGroupDetails[]>
      (ApiConstants.AssignmentGroup_api + '/' + `${scope}` + '/' + `${isAllAssignmentGroups}`);
  }


  getAssignmentGroups(assignmentGroupsRequest: AssignmentGroupsRequest){
    return this.httpClient.post(ApiConstants.AssignmentGroups_OnScopeChange_API, assignmentGroupsRequest)
  }

  getActiveAndInActiveAssignmentGroups(assignmentGroupsRequest: AssignmentGroupsRequest){
    return this.httpClient.post(ApiConstants.ActiveAndInactiveAssignmentGroups_OnScopeChange_API, assignmentGroupsRequest)
  }

  updateAssignmentGroup(assignmentGroupId:string,
    assignmentGroup: AssignmentGroup): Observable<any> {
    return this.httpClient.put(ApiConstants.AssignmentGroup_api+ '/' + `${assignmentGroupId}`, assignmentGroup)
  }

  getEQMSScopeForAssignmentGroups(): Observable<EQMSScopeHierarchy> {
    if(this.eqmsScopeObservable) {
      return this.eqmsScopeObservable;
    }
    if (Object.keys(this.treeData).length > 0) {
      this.eqmsScopeObservable = of(this.treeData);
    }
    else {
      this.eqmsScopeObservable = this.httpClient.get<EQMSScopeHierarchy>(ApiConstants.EQMSScopesForAssignmentGroups_Api)
        .pipe(
          tap(treeData => this.treeData = treeData),
          shareReplay(1)
        );
    }
    return this.eqmsScopeObservable;
  }
  getEQMSScopeTreeNodes = (scopeHierarchy: EQMSScopeHierarchy): TreeNode[] => {
    let treeNodes: TreeNode[] = [];
    treeNodes.push(this.createTreeNode(scopeHierarchy));
    return treeNodes;
  }
  
  private createTreeNode(node: any): TreeNode {
    const isNodeEnabled = node.isEnable; 

    return {
      label: node.eQMSScopeName,
      data: node,
      expanded: true,
      selectable: node.isEnable,
      children: node.children ? this.createChildNodes(node.children) : undefined,
      style: isNodeEnabled ? 'color: #000000' : 'color: #888'
    };
  }
  
  private createChildNodes(nodes: any[]): TreeNode[] {
    return nodes.map(childNode => this.createTreeNode(childNode));
  }
  
  getAGsAuthorization(): Observable<any>{
    return this.httpClient.get<any>(ApiConstants.AssignmentGroup_Authorization_api);
  }

  clearEQMSScopeCache(): void {
  this.eqmsScopeObservable = undefined;
}
}
